/**
 * Analytics Service - Universal tracking for GTM dataLayer
 * All events push to window.dataLayer (existing GTM setup)
 */

/**
 * Get user tracking params for analytics events
 * Returns user_type, user_name based on login state
 */
export const getUserTrackingParams = (user) => {
  if (!user?.details?._id) return { user_type: "public" };
  const role = user.details.role;
  return {
    user_type: role === "Patient" ? "patient_user" : role === "Therapist" ? "therapist_user" : "public",
    user_name: `${user.details.first_name || ""} ${user.details.last_name || ""}`.trim(),
  };
};

const pushToDataLayer = (data) => {
  if (process.env.REACT_APP_PRODUCTION_MODE !== "true") return;
  window.dataLayer = window.dataLayer || [];
  // Remove undefined/null/empty string values
  const cleanData = Object.fromEntries(
    Object.entries(data).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  window.dataLayer.push(cleanData);
};

/**
 * Track screen view events
 * @param {string} event_name - e.g. "onboarding_screen", "login_screen" — used as the event name
 * @param {object} params - optional: { screen_name, user_name, therapist_name }
 */
export const trackScreenView = (event_name, params = {}) => {
  pushToDataLayer({
    event: event_name,
    event_type: "screen_view",
    ...params,
  });
};

/**
 * Track button click events
 * @param {string} event_name - e.g. "signup_cta", "login_cta" — used as the event name
 * @param {object} params - optional: { button_name, screen_name, user_name, therapist_name }
 */
export const trackButtonClick = (event_name, params = {}) => {
  pushToDataLayer({
    event: event_name,
    event_type: "button_click",
    ...params,
  });
};

/**
 * Track custom funnel/revenue events
 * @param {string} event_name - e.g. "app_open", "login", "purchase"
 * @param {object} params - optional: { user_name, therapist_name, value, currency, transaction_id }
 */
export const trackEvent = (event_name, params = {}) => {
  pushToDataLayer({
    event: event_name,
    ...params,
  });
};
